import { render } from "./ModalEditConstruction.vue?vue&type=template&id=64fe7e6f&scoped=true"
import script from "./ModalEditConstruction.vue?vue&type=script&lang=js"
export * from "./ModalEditConstruction.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-64fe7e6f"

export default script